<template>
  <div class="tlqn-hamburger-btn">
    <input
      type="checkbox"
      :disabled="disable"
      :checked="value"
      @input="handleInput"
    />
    <span></span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    disable: {
      type: Boolean,
      default: false,
    },
  },

  model: {
    prop: "value",
    event: "change",
  },

  methods: {
    handleInput(e) {
      const { checked } = (e || {}).target || {};
      // console.log(checked);
      this.$emit("change", checked);
    },
  },
};
</script>

<style lang="scss">
.tlqn-hamburger-btn {
  width: 30px;
  height: 30px;
  color: inherit;
  position: relative;

  input {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    opacity: 0;
    z-index: 1;
  
    &:disabled {
      opacity: 0 !important;
      cursor: not-allowed;
    }
  }

  span {
    width: 80%;
    &,
    &::after,
    &::before {
      position: absolute;
      display: block;
      height: 2px;
      background-color: currentColor;
      left: 50%;
      transform: translate(-50%, -50%);
      top: 50%;
    }

    &::after,
    &::before {
      content: "";
      width: 100%;
    }

    transition: all 0.13s ease;
    &::before {
      transform: translate(-50%, calc(-50% - 300%));
      transition: all 0.23s ease;
    }
    &::after {
      transform: translate(-50%, calc(50% + 250%));
      transition: all 0.33s ease;
    }
  }

  input:checked ~ span {
    transform: translate(-50%, -50%) rotate(45deg);
    &::before {
      transform: translate(-50%, -50%) rotate(90deg);
    }
    &::after {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }
}
</style>
